import { create } from 'zustand';

export const initialState = {
    search: '',
    page: 1,
    limit: 10,
};

export const useFilter = create((set) => ({
    ...initialState,
    setFilter: (newState) => set((state) => ({ ...state, ...newState })),
    resetFilter: () => set(() => ({ ...initialState })),
}));
